import { RouteRecordRaw } from 'vue-router';
import ResourceAllPage from '/@pages/ResourceEventsPage/ResourceAllPage.vue';
import ResourceUserPage from '/@pages/ResourceEventsPage/ResourceUserPage.vue';
import ResourceGroupsPage from '/@pages/ResourceGroupsPage/ResourceGroupsPage.vue';
import ResourcesSearchPage from '/@pages/ResourcesSearchPage/ResourcesSearchPage.vue';
import ScheduleFilterPage from '/@pages/ScheduleFilterPage/ScheduleFilterPage.vue';
import SchedulePage from '/@pages/SchedulePage/SchedulePage.vue';

export const ressursRoutes: Array<RouteRecordRaw> = [
  {
    path: '/resources/all',
    component: ResourceAllPage,
    meta: { gate: 'ressurs' },
  },
  {
    path: '/resources/events',
    component: ResourceUserPage,
    props: ({ query }) => ({ view: query.view }),
    meta: { gate: 'ressurs' },
  },
  {
    path: '/resources/schedule',
    component: SchedulePage,
    meta: { gate: 'ressurs' },
  },
  {
    path: '/resources/search',
    component: ResourcesSearchPage,
    meta: { gate: 'ressurs' },
  },
  {
    path: '/resources/groups/:filterId?',
    component: ResourceGroupsPage,
    props: ({ params }) => ({ filterId: Number(params.filterId) }),
    meta: { gate: 'ressurs' },
  },
  {
    path: '/resources/schedulefilter',
    component: ScheduleFilterPage,
    meta: { gate: 'ressurs' },
  },
];
